export const BREAKPOINTS = {
  SM: 480,
  MD: 768,
}
